const CHAPTERS_COLUMNS = [
  {
    field: "title",
    headerName: "Titull",
    width: 400,
    minWidth: 400,
    flex: 1,
    editable: false,
  },
  {
    field: "order",
    headerName: "Rendi",
    width: 80,
    maxWidth: 80,
    minWidth: 80,
    flex: 1,
    editable: false,
  },
];

export default CHAPTERS_COLUMNS;
